import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputAdornment from "@mui/material/InputAdornment";

import { ReactComponent as DeleteIcon } from "../../../assets/images/delete1.svg";

import { CHARGE_TYPE, GENERAL_CHARGES_FIELDS, ORDER_TYPE_OPTIONS, getItemKey } from "./constants";

import SettingTextField from "../../../components/SettingTextField";
import SettingSelectField from "../../../components/SettingSelectField";
import SwitchInput from "../../../components/SwitchInput";

const ChargeCard = ({ index, chargeData, onInputChange, errors, onDelete }) => {

    return (
        <Card variant="outlined" sx={{ padding: "1rem", marginBottom: "1rem", backgroundColor: "#f9f9f9" }}>
            <Box
                sx={{
                    display: 'grid',
                    gap: 2,
                    gridTemplateColumns: 'repeat(auto-fill, minmax(22rem, 1fr))',
                    width: '100%',
                    alignItems: 'stretch',
                }}
            >
                <SettingTextField
                    value={chargeData[GENERAL_CHARGES_FIELDS.NAME]}
                    setValue={(val) => onInputChange(val, index, GENERAL_CHARGES_FIELDS.NAME)}
                    label={"Charge Name"}
                    required={true}
                    labelStyle={styles.labelStyle}
                    border={"1px solid #AAA"}
                    variant={"filled"}
                    error={errors.get(getItemKey(index, GENERAL_CHARGES_FIELDS.NAME, CHARGE_TYPE.OTHER))}
                />

                <SettingTextField
                    value={chargeData[GENERAL_CHARGES_FIELDS.VALUE]}
                    setValue={(val) => onInputChange(val, index, GENERAL_CHARGES_FIELDS.VALUE)}
                    required={true}
                    label={"Amount"}
                    labelStyle={styles.labelStyle}
                    border={"1px solid #AAA"}
                    variant={"filled"}
                    error={errors.get(getItemKey(index, GENERAL_CHARGES_FIELDS.VALUE, CHARGE_TYPE.OTHER))}
                    inputTextStyle={{ autoComplete: "off" }}
                    textAlign={chargeData[GENERAL_CHARGES_FIELDS.PERCENTAGE] ? "right" : "left"}
                    leftView={!chargeData[GENERAL_CHARGES_FIELDS.PERCENTAGE] &&
                        <Box>£</Box>
                    }
                    rightView={chargeData[GENERAL_CHARGES_FIELDS.PERCENTAGE] && <InputAdornment position="end" >
                        <Box>%</Box>
                    </InputAdornment >}
                />

                <SettingSelectField
                    value={Number(chargeData[GENERAL_CHARGES_FIELDS.ORDER_TYPE])}
                    setValue={(val) => { onInputChange(val, index, GENERAL_CHARGES_FIELDS.ORDER_TYPE) }}
                    editable={true}
                    placeholder={"Select Order type"}
                    required={true}
                    variant={"filled"}
                    label={"Category"}
                    labelStyle={styles.labelStyle}
                    border={"1px solid #AAA"}
                    error={errors.get(getItemKey(index, GENERAL_CHARGES_FIELDS.ORDER_TYPE, CHARGE_TYPE.OTHER))}
                    menuList={ORDER_TYPE_OPTIONS}
                />

                <SettingTextField
                    value={chargeData[GENERAL_CHARGES_FIELDS.CUSTOMER_VISIBLE_MESSAGE] || ""}
                    setValue={(val) => onInputChange(val, index, GENERAL_CHARGES_FIELDS.CUSTOMER_VISIBLE_MESSAGE)}
                    label={"Customer Visible Message"}
                    required={false}
                    labelStyle={styles.labelStyle}
                    border={"1px solid #AAA"}
                    variant={"filled"}
                    error={errors.get(getItemKey(index, GENERAL_CHARGES_FIELDS.CUSTOMER_VISIBLE_MESSAGE, CHARGE_TYPE.OTHER))}
                    placeholder={"Enter message visible to customers (optional)"}
                    multiline={true}
                    rows={2}
                />

                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', height: '100%' }}>
                    {/* Dummy div container with transparent to offset the heights of other input labels */}
                    <Box sx={{ ...styles.labelStyle, width: "100%", color: "transparent" }} mb={0.8}>Controls</Box>
                    <Box sx={{ flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <SwitchInput
                                        checked={chargeData[GENERAL_CHARGES_FIELDS.PERCENTAGE]}
                                        onChange={(val) => onInputChange(val, index, GENERAL_CHARGES_FIELDS.PERCENTAGE)}
                                        inputProps={{ "aria-label": "ant design" }}
                                    />
                                }
                                sx={{
                                    fontSize: '14px !important',
                                    fontFamily: 'GilroySemiBold !important',
                                    color: '#000000',
                                    margin: 0,
                                    '& .MuiTypography-root': {
                                        marginLeft: '0.5rem',
                                        whiteSpace: 'nowrap' // Prevents label from wrapping
                                    }
                                }}
                                label="Set as Percentage"
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <SwitchInput
                                        checked={chargeData[GENERAL_CHARGES_FIELDS.ACTIVE]}
                                        onChange={(val) => onInputChange(val, index, GENERAL_CHARGES_FIELDS.ACTIVE)}
                                        inputProps={{ "aria-label": "ant design" }}
                                    />
                                }
                                sx={{
                                    color: '#000000',
                                    margin: 0,
                                    '& .MuiTypography-root': {
                                        marginLeft: '0.5rem',
                                        whiteSpace: 'nowrap'
                                    }
                                }}
                                label="Is Active"
                            />
                        </FormGroup>

                        <Box
                            className={styles.actionBox}
                            sx={{
                                alignSelf: { xs: 'flex-start', md: 'center' },
                                path: {
                                    stroke: "red"
                                }
                            }}
                        >
                            <DeleteIcon
                                height={28}
                                width={28}
                                style={{ cursor: "pointer", color: 'red' }}
                                onClick={() => onDelete(index, chargeData)}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Card >
    )
}

export default ChargeCard;

const styles = {
    container: {
        background: '#f9f9f9',
    },
    labelStyle: {
        fontSize: 14,
        fontFamily: "GilroySemiBold",
        textAlign: "left"
    },
    actionBox: {
        display: "flex",
        justifyContent: "flex-end",
    }
};